<template>
  <div :class="imgcss">
    <div :class="customer">
      <a target="_blank" :href="data.filePath">
        <img :src="data.previewImageUrl" @load="getWidth">        
      </a>
       <div class="play-icon"></div>
    </div>
  </div>
</template>

<script>
import Global from "@/components/Global";
export default {
  name: "VideoMessage",
  props: ["data"],
  data() {
    return {
      imgcss: "attachImg video"
      //imgcss: "attachImg video V-img"
    };
  },
  computed: {
    customer() {
      let result = false;
      result = this.data.senderType === 1;
      return result
        ? "message my-message"
        : "message other-message float-right";
    }
  },
  methods: {
    getWidth(event) {
      // if (event.target.height > event.target.width) {
      //   this.imgcss = "attachImg V-img";
      // }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/VideoMessage.vue